import { Divider, Stack, Typography } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Entitlement } from './Entitlement';
import { HiddenAccessibilityText } from 'Components/HiddenAccessibilityText';
import { useContext, useState } from 'react';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { useDictionary, useIsDesktop } from 'Hooks';
import { NoResults2 } from 'Components';
import { LastUpdated } from '../../CompassHeader/LastUpdated';
import { PrintForm } from '../../CompassHeader/PrintForm';
import { ENTITLEMENT_TYPES } from 'Enum/CompassRights';

interface IEntitlementsList {
  lastUpdateDate?: Date;
}

export const EntitlementsList = ({ lastUpdateDate }: IEntitlementsList) => {
  const { entitlements, entitlementTypes } = useContext(EntitlementsContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);
  const isDesktop = useIsDesktop();

  const getFilteredEntitlements = () => {
    return (
      entitlements?.filteredEntitlements?.filter((entitlement) => {
        if (entitlementTypes.length === 0) return true;
        if (entitlementTypes.length === 1) {
          if (entitlementTypes[0] === ENTITLEMENT_TYPES.automatic) {
            return entitlement.automatic;
          } else return entitlement.oneTime;
        } else return entitlement.automatic || entitlement.oneTime;
      }) || []
    );
  };

  return (
    <Stack minHeight='200px' gap='24px'>
      <HiddenAccessibilityText
        text={`${dictionary.accessibilityFoundResults.found} ${
          getFilteredEntitlements().length
        } ${dictionary.accessibilityFoundResults.results}`}
      />
      {entitlements?.filteredEntitlements?.length > 0 ? (
        <Stack gap={'32px'}>
          <Stack
            flexDirection={isDesktop ? 'row' : 'column-reverse'}
            alignItems={isDesktop ? 'center' : undefined}
            justifyContent={'space-between'}
            gap={isDesktop ? undefined : '24px'}
          >
            <Typography variant='body2'>
              {dictionary.resultsFound(getFilteredEntitlements().length)}
            </Typography>
            <Stack
              direction='row'
              alignItems='center'
              justifyContent={isDesktop ? 'flex-end' : 'flex-start'}
              gap={'16px'}
              width={'fit-content'}
            >
              <LastUpdated lastUpdateDate={lastUpdateDate} />
              <Divider
                aria-hidden={'true'}
                orientation='vertical'
                flexItem
                sx={{ borderColor: 'primary.shade_100' }}
              />
              <PrintForm />
            </Stack>
          </Stack>
          <Stack gap={'32px'} className='print-only'>
            {getFilteredEntitlements().map(
              (entitlement: IEntitlement, index: number) => {
                return <Entitlement entitlement={entitlement} key={index} />;
              }
            )}
          </Stack>
          {getFilteredEntitlements().map(
            (entitlement: IEntitlement, index: number) => {
              return <Entitlement entitlement={entitlement} key={index} />;
            }
          )}
        </Stack>
      ) : (
        <NoResults2 />
      )}
    </Stack>
  );
};
